<template>
  <div>
    <!-- <direct-required-details  /> -->
    <vx-card :id="cardId" class="vs-con-loading__container">
      <card-header :title="$t(cardTitle)" v-model="params.search" @search="search" @close="close"/>
      <headcount-table
        :data="data"
        @showDetails="showDetails"
        @loadMore="loadMore"
        @search="search"
      />
    </vx-card>
  </div>
</template>



<script>
import HeadcountTable from '../tables/HeadcountTable.vue'
// import IndirectRequiredDetails from './IndirectRequiredDetails.vue'
import CardHeader from '../components/CardHeader.vue'
import dashboard from '@/http/requests/dashboard'

export default {
  name: 'headcount-card',
  components: {
    // IndirectRequiredDetails,
    HeadcountTable,
    CardHeader,
  },
  props: {
    // statusId: {
    //   type: [String, Number],
    //   required: true,
    // },
  },
  data() {
    return {
      cardTitle: 'headcount',
      cardId:'loading-headcount-card',
      data: [],
      lastPage: 1,
      loading: false,
      params: {
        page: 1,
        search: '',
      },
    }
  },
  methods: {
    getData() {
      this.loading = true
      window.scrollTo(0,document.body.scrollHeight);
      dashboard
        .headcountList(this.params)
        .then((response) => {
          if (this.params.page === 1) {
            this.data = [...response.data.data]
          } else {
            this.data = [...this.data, ...response.data.data]
          }
          // this.lastPage = response.data.result.last_page
          this.loading = false
        })
        .catch((response) => {
          this.showValidationErrors(response)
          this.loading = false
        })
    },
    loadMore() {
      if (this.params.page >= this.lastPage) {
        return
      }
      this.params.page++
      this.getData()
    },
    search() {
      this.params.page = 1
      this.getData()
    },
    showDetails(e) {
    //   this.ehsId = e
      this.$store.dispatch('toggleSidebar', 'sidebar-direct-required-details')
    },
    close() {
      this.$emit('close')
    },
  },
  mounted() {
    this.getData()
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#${this.cardId}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#${this.cardId} > .con-vs-loading`)
      }
    }
  },
}
</script>

